import HttpRequest from "./http_request";

class RefProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_CENTRAL_API_URL + "reference/");
  }

  async getLevel() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "LEVEL",
      select: ["LEVEL_ID", "LEVEL_NAME_TH", "LEVEL_NAME_EN"],
      order: [
        {
          LEVEL_ID: "ASC",
        },
      ],
    });
    return data;
  }

  async getTeachTableSubjectOwner() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "TEACH_TABLE_SUBJECT_OWNER",
      select: [
        "TEACH_TABLE_SUBJECT_OWNER_ID",
        "TEACH_TABLE_SUBJECT_OWNER_NAME_TH",
        "TEACH_TABLE_SUBJECT_OWNER_NAME_EN",
        "TEACH_TABLE_SUBJECT_TYPE_ID",
        "TEACH_TABLE_SUBJECT_OWNER_NAME_MAIN_PAGE_TH",
        "TEACH_TABLE_SUBJECT_OWNER_NAME_MAIN_PAGE_EN",
        "TEACH_TABLE_SUBJECT_OWNER_MAIN_PAGE",
      ],
      order: [
        {
          TEACH_TABLE_SUBJECT_OWNER_NAME_MAIN_PAGE_TH: "ASC",
        },
      ],
    });
    return data;
  }
  async getTeachTableSubjectOwnerOnlyTeachService() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "TEACH_TABLE_SUBJECT_OWNER",
      select: [
        "TEACH_TABLE_SUBJECT_OWNER_ID",
        "TEACH_TABLE_SUBJECT_OWNER_NAME_MAIN_PAGE_TH",
        "TEACH_TABLE_SUBJECT_OWNER_NAME_MAIN_PAGE_EN",
      ],
      where: [
        {
          TEACH_TABLE_SUBJECT_TYPE_ID: "1",
          TEACH_TABLE_SUBJECT_OWNER_MAIN_PAGE: "1",
        },
      ],
      order: [
        {
          TEACH_TABLE_SUBJECT_OWNER_NAME_MAIN_PAGE_TH: "ASC",
        },
      ],
    });
    return data;
  }
  async getTeachTableSubjectType() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "TEACH_TABLE_SUBJECT_TYPE",
      select: [
        "TEACH_TABLE_SUBJECT_TYPE_ID",
        "TEACH_TABLE_SUBJECT_TYPE_NAME_TH",
        "TEACH_TABLE_SUBJECT_TYPE_NAME_EN",
      ],
    });
    return data;
  }

  async getGraduateSubjectOwner() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "TEACH_TABLE_GRAD_SUBJECT_OWNER",
      select: [
        "SUBJECT_OWNER_ID",
        "SUBJECT_OWNER_NAME_TH",
        "SUBJECT_OWNER_NAME_EN",
        "LEVEL_ID",
      ],
      order: [
        {
          SUBJECT_OWNER_ID: "ASC",
        },
      ],
    });
    return data;
  }

  async getTeachTableTeachType() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "TEACH_TABLE_TEACH_TYPE",
      select: [
        "TEACH_TABLE_TEACH_TYPE_ID",
        "TEACH_TABLE_TEACH_TYPE_NAME_TH",
        "TEACH_TABLE_TEACH_TYPE_NAME_EN",
      ],
    });
    return data;
  }
  async getTeachTableExamType() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "TEACH_TABLE_EXAM_TYPE",
      select: [
        "TEACH_TABLE_EXAM_TYPE_ID",
        "TEACH_TABLE_EXAM_TYPE_NAME_TH",
        "TEACH_TABLE_EXAM_TYPE_NAME_EN",
      ],
      order: [
        {
          SORT: "ASC",
        },
      ],
    });
    return data;
  }
  async getTeachTableExamText() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "TEACH_TABLE_EXAM_TEXT",
      select: [
        "TEACH_TABLE_EXAM_TEXT_ID",
        "TEACH_TABLE_EXAM_TEXT_NAME_TH",
        "TEACH_TABLE_EXAM_TEXT_NAME_EN",
      ],
    });
    return data;
  }
  async getSubjectRuleType() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "TEACH_TABLE_SUBJECT_RULE_TYPE",
      select: [
        "TEACH_TABLE_SUBJECT_RULE_TYPE_ID",
        "TEACH_TABLE_SUBJECT_RULE_TYPE_NAME_TH",
        "TEACH_TABLE_SUBJECT_RULE_TYPE_NAME_EN",
      ],
    });
    return data;
  }
  async getStudyPlan() {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "STUDY_PLAN",
      select: [
        "STUDY_PLAN_ID",
        "LEVEL_ID",
        "REGISTRAR_PROGRAM_ID",
        "REGISTRAR_SUB_PROGRAM_ID",
        "STUDY_PLAN_NAME_TH",
        "STUDY_PLAN_NAME_EN",
        "STUDY_PLAN_NAME_TH_BELOW_2566",
        "STUDY_PLAN_NAME_EN_BELOW_2566",
      ],
    });
    return data;
  }
  async getStudyAdmitTypeByLevel(level_id) {
    const { data } = await this.get("/", {
      function: "get-reference",
      table: "STUDY_ADMIT_TYPE",
      select: [
        "STUDY_ADMIT_TYPE_ID",
        "REGISTRAR_ADMIT_TYPE_ID",
        "STUDY_ADMIT_TYPE_NAME_TH",
        "STUDY_ADMIT_TYPE_NAME_EN",
      ],
      where: [
        {
          LEVEL_ID: level_id,
        },
      ],
    });
    return data;
  }
}

export default RefProvider;
